module.exports = __webpack_public_path__ + "img/alexeev.38323b4e.png";